module.exports = __webpack_public_path__ + "img/SES_140250044.6e3a3eff.jpg";